import { Flex } from 'antd'

/*
 * @Author: Tina Huang
 * @Date: 2024-07-18 10:46:46
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:50:31
 * @Description:
 */

import styles from './index.module.css'

export default function MayDaySticker() {
  return (
    <div className="p-6">
      {/* <h1 className="font-bold text-8xl text-center">MAYDAY</h1> */}
      <Flex>
        <div className={styles.sticker}>
          <h2>2024 五月天[回到那一天]25周年-北京演唱会</h2>
        </div>
      </Flex>
    </div>
  )
}
